import React from "react";

const DEFAULT_IMAGE = "https://cdn-icons-png.flaticon.com/512/847/847969.png";

const MemberAvatar = ({ member, size = "32px" }) => {
  const styles = {
    avatar: {
      width: size,
      height: size,
      borderRadius: "50%",
      border: "2px solid #1c1c1c",
      objectFit: "cover",
      backgroundColor: "#ccc",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff",
      fontSize: "14px",
      fontWeight: "bold",
    },
  };

  return (
    <img
      src={member?.image || DEFAULT_IMAGE}
      alt={member?.name || "Member"}
      style={styles.avatar}
    />
  );
};

export default MemberAvatar;
